import axios from 'axios';

export default {
  fetchFileList(_, { domain, params }) {
    return axios.get(domain, { params });
  },
};
